export default __webpack_public_path__ + "static/media/hht2_ep8_speaking_03.aea3514d.png";